import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { newId } from '../api.js';
import { JobPage } from '../components.jsx';
import { enqueue } from '../lib/outbox.js';

function Form({ job }) {
  const nav = useNavigate();
  const [text, setText] = useState('');
  const [sid] = useState(newId);
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    await enqueue([{ id: sid, kind: 'note', jobId: job.id, jobName: job.name, sid, text: text.trim() }]);
    nav(`/job/${job.id}/done?what=note&sid=${sid}`, { replace: true });
  }

  return (
    <>
      <textarea
        className="input min-h-[40vh] !text-lg"
        placeholder="Type your note here…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={5000}
        autoFocus
      />
      <button className="btn-primary w-full" disabled={!text.trim() || busy} onClick={save}>Save note</button>
    </>
  );
}

export default function AddNote() {
  return <JobPage title="Add a note">{(job) => <Form job={job} />}</JobPage>;
}
